import * as dat from 'lil-gui'

/**
 * Debug - A class for enabling and managing debugging UI using lil-gui.
 * @category Experience
 * @subcategory Utils
 */

export default class Debug
{
    /**
     * Constructs the Debug class.
     * Activates the debugging UI if the URL hash is set to '#debug'.
     */
    constructor()
    {
        /**
         * @property {boolean} active - Indicates whether debugging is active.
         */
        this.active = window.location.hash === '#debug'

        /**
         * @property {dat.GUI|null} ui - The GUI instance for debugging, initialized if active.
         */
        if(this.active)
        {
            this.ui = new dat.GUI()
        }
    }
    cleanup() {
        if (this.ui) {
            this.ui.destroy(); // Destroy the GUI instance
            this.ui = null;
            console.log("Debug UI cleaned up.");
        }
    }
}